import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Typography, Space, Row } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import facility_default from 'assets/facility_default.png';
import { EntityCardWrapper, EntityImage } from './styled';
var Text = Typography.Text;
var FacilityCard = function (_a) {
    var id = _a.id, name = _a.name, avatarSrc = _a.avatarSrc, onDelete = _a.onDelete;
    return (_jsx(EntityCardWrapper, { children: _jsxs(Row, { align: "middle", justify: "space-between", children: [_jsxs(Space, { children: [_jsx(EntityImage, { children: _jsx("img", { src: avatarSrc || facility_default, alt: "facility", onError: function (_a) {
                                    var currentTarget = _a.currentTarget;
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = facility_default;
                                } }) }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column' }, children: [_jsx(Text, { strong: true, children: name }), _jsx("a", { href: "/facilities/".concat(id), children: "Edit Profile" })] })] }), _jsx(DeleteOutlined, { size: 20, style: { fontSize: '20px', color: '#2064D2', cursor: 'pointer' }, onClick: onDelete })] }) }));
};
export default FacilityCard;
